import { voucherAppliesToProducts } from './voucherAppliesToProducts';

export default voucherAppliesToProducts;
